import React, { useEffect, useState } from "react";
import axios from "axios";
import CosmeticOwnerTable from "./CosmeticOwnerTable";

export function CosmeticOwner({ type, id }) {
  const [ownersResponse, setOwnersResponse] = useState();
  const [data, setData] = useState();
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    axios
      .get(`https://app.zeqa.net/api/owners/${type}/${id}`, {
      })
      .then((resp) => {
        if (resp.status === 200) {
          setOwnersResponse(resp.data.result);
        }
      });
  }, [id, type]);

  useEffect(() => {
    if (!ownersResponse) return;

    let owners = [];
    let total_count = 0;

    ownersResponse.forEach((element) => {
      const items = element["owned" + type].split(",");
      const count = items.filter((x) => x === id).length;
      if (count > 0) {
        owners.push({
          name: element.name,
          count,
        });
        total_count += count;
      }
    });

    setData({ total_count, owners });
  }, [ownersResponse, id, type]);

  const filteredOwners = data
    ? data.owners.filter((owner) =>
        owner.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];

  if (!data) {
    return (
      <h1
        style={{
          color: "#ffc800",
          paddingTop: 15,
          paddingBottom: 15,
          fontSize: 18,
        }}
      >
        Owners Loading...
      </h1>
    );
  }

  return (
    <div>
      <h1 style={{ color: "#ffc800", marginBottom: 20, fontSize: 18 }}>
        Current Owners
      </h1>
      <h4
        style={{
          marginBottom: 10,
          fontSize: 15,
          fontFamily: "Minecraft Seven",
        }}
      >
        Existing Items : {data.total_count}
      </h4>
      <div className="cosmetic_display_search">
        <input
          type="text"
          placeholder="Search player name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <br></br>
      <CosmeticOwnerTable owners={filteredOwners} />
    </div>
  );
}
